export default __webpack_public_path__ + "static/media/logo.809829c1.png";